import React from 'react';
import classNames from 'classnames';
import ContentfulRichText from '@/components/ContentfulRichText/ContentfulRichText';
import {
  bgColorMap,
  paddingTopSizeMap,
  paddingBotSizeMap,
  textColorMap,
} from '@/utils/styleHelpers';
import { DescriptionType } from '@/utils/common.types';

interface Props {
  title: string;
  titleSizing?: string;
  description?: DescriptionType;
  disclaimer: string;
  paragraphStyle?: string;
  textColorTw?: string;
  backgroundColorTw?: string;
  paddingTop: string;
  paddingBottom: string;
  includeSegment?: boolean;
}

const IntroCard = ({
  title,
  titleSizing = 'Medium',
  description,
  disclaimer,
  paragraphStyle,
  textColorTw = 'default',
  backgroundColorTw = 'default',
  paddingTop = '',
  paddingBottom = '',
  includeSegment = false,
}: Props) => {
  if (description && includeSegment)
    description.includeSegment = includeSegment;

  return (
    <div
      className={classNames(
        'mx-auto my-0 w-mobile max-w-standard pt-[30px] font-source-sans',
        { [bgColorMap(backgroundColorTw)]: backgroundColorTw },
        {
          [paddingTopSizeMap(paddingTop)]: paddingTop,
        },
        {
          [paddingBotSizeMap(paddingBottom)]: paddingBottom,
        }
      )}
    >
      <div className="mx-auto my-0 w-full pr-0 text-center">
        <h2
          className={classNames(
            'mb-[30px] font-acumin font-bold leading-[1.145] tracking-[-0.35px]',
            `${paragraphStyle === 'left' ? 'text-left md:mr-[25%]' : 'text-center'}`,
            {
              ['text-[16px] md:text-[18px] lg:text-[22px]']:
                titleSizing === 'small' || titleSizing === 'Small',
              ['text-[22px] md:text-[26px] lg:text-[35px]']:
                titleSizing === 'medium' ||
                titleSizing === 'Medium' ||
                titleSizing === null,
              ['text-[34px] md:text-[2.75rem] lg:text-[3.75rem]']:
                titleSizing === 'large' || titleSizing === 'Large',
            },
            textColorMap(textColorTw)
          )}
        >
          {title}
        </h2>
        {description && (
          <div
            className={classNames(
              'mb-[15px] leading-[1.69] *:text-[1rem] lg:*:text-[1.15rem]',
              `${paragraphStyle === 'left' ? 'text-left' : 'text-center'}`,
              textColorMap(textColorTw)
            )}
          >
            {ContentfulRichText({ ...description })}
          </div>
        )}
        <p
          className={classNames(
            'mb-[15px] text-[0.85rem] leading-[1.42]',
            `${paragraphStyle === 'left' ? 'text-left' : 'text-center'}`,
            textColorMap(textColorTw)
          )}
        >
          {disclaimer}
        </p>
      </div>
    </div>
  );
};

export default IntroCard;
